<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
      <div class="text-5xl mb-4">{{ step.icon }}</div>
      <h2 class="text-2xl font-bold text-gray-900 dark:text-gray-100">{{ step.title }}</h2>
      <p class="mt-3 text-gray-600 dark:text-gray-300">{{ step.body }}</p>

      <!-- progress dots -->
      <div class="flex justify-center gap-2 mt-6">
        <span
          v-for="(s, i) in steps" :key="i"
          class="w-2 h-2 rounded-full transition-colors"
          :class="i === index ? 'bg-emerald-600' : 'bg-gray-200'"
        ></span>
      </div>

      <div class="mt-7 flex items-center justify-between gap-3">
        <button @click="finish" class="text-sm text-gray-400 hover:text-gray-600">Skip</button>
        <div class="flex gap-2">
          <button
            v-if="index > 0"
            @click="index--"
            class="px-4 py-2 rounded-xl bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-medium hover:bg-gray-200 dark:hover:bg-gray-600"
          >Back</button>
          <button
            @click="next"
            class="px-5 py-2 rounded-xl bg-emerald-600 text-white font-medium hover:bg-emerald-700"
          >{{ index < steps.length - 1 ? 'Next' : "Let's go!" }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const emit = defineEmits(['done'])

const steps = [
  { icon: '👋', title: 'Welcome to Speak Saigon', body: 'Learn Southern Vietnamese with short, daily lessons — vocabulary, grammar, speaking, and games. Prefer the Northern accent? Flip the Saigon/Hanoi switch in the header (it\'s in beta).' },
  { icon: '🇦', title: 'Start at the start', body: 'Begin with Unit 0 — the alphabet and the tones (5 in the Southern accent, 6 in Hanoi mode) — then work your way up through the units.' },
  { icon: '🔥', title: 'Earn XP, build a streak', body: 'Every lesson, review, and game earns XP. Practice each day to grow your streak and level up.' },
  { icon: '🎤', title: 'Speak out loud', body: 'Some exercises listen to your pronunciation. We’ll ask for microphone access the first time you need it.' },
  { icon: '🎯', title: 'Match the tones', body: 'Tone Trainer on the dashboard overlays your pitch curve on the reference for any word or sentence — watch the shapes line up as you improve.' },
  { icon: '⌨️', title: 'Type Vietnamese, no keyboard needed', body: 'When an exercise asks you to type, tap the accent bar above the box to add Vietnamese letters and tones — on any device. Tones count by default; you can relax that in Settings.' },
  { icon: '🎮', title: 'Keep it fun', body: 'Short on time? The Daily Challenge and games are a quick way to practice what you’ve learned.' },
]

const index = ref(0)
const step = computed(() => steps[index.value])

function next() {
  if (index.value < steps.length - 1) index.value++
  else finish()
}

function finish() {
  emit('done')
}
</script>
